const tr = {
  doctor_schedules:{
    attributes:{
      id: 'ID',
      doctor: 'Médico',
      doctor_id: 'Médico',
      duration: 'Duração das consultas',
      begin_date: 'Data inicial',
      end_date: 'Data final',
      begin_time: 'Início do horário',
      end_time: 'Fim do horário',
      is_closed: 'Restringir',
      available: 'Disponível',
      is_sunday: 'Domingo',
      is_monday: 'Segunda',
      is_tuesday: 'Terça',
      is_wednesday: 'Quarta',
      is_thursday: 'Quinta',
      is_friday: 'Sexta',
      is_saturday: 'Sábado',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
    },
    extras:{
      create: 'Novo Horário',
      edit: 'Editando Horário',
      show: 'Visualizando Horário',
      delete: 'Excluir Horário',
    },
    defSingular: 'Horário',
    defPlural: 'Horários',
  }
};

export default tr;
